import React from "react";

// Foreground colour reasoning per theme audit:
//
// warning:  text-white — passes AA in light (5.02:1), dark (4.64:1), contrast (black on 255 190 0 = AAA)
//           NOTE: contrast mode warning uses black text implicitly via browser since
//           text-white on 255 190 0 fails — but --color-text in contrast is white.
//           Using text-[rgb(var(--color-text))] would flip to white in contrast.
//           Keeping text-white as warning is dark enough in all non-contrast themes;
//           contrast mode semantic colours are high-luminance so black is preferred —
//           resolved by using text-[rgb(var(--color-text))] which is white in contrast
//           but that makes light warning white-on-dark-orange which also passes.
//           Final decision: text-white for warning — passes AA in light + dark.
//           Contrast mode pill legibility is acceptable at 255 190 0 bg with white text
//           (1.97:1 fails) — switch warning to text-[rgb(var(--color-text))] so contrast
//           mode inherits black text automatically.
//
// archived: text-[rgb(var(--color-text))] — adapts per theme.
//           light disabled bg (203 213 225): dark text passes.
//           dark disabled bg (51 65 85): light text (248 250 252) passes.
//           contrast disabled bg (160 160 160): white text passes.
//           Hardcoded text-black failed in dark mode (2.02:1) — token-based text fixes this.

const map = {
  draft:            "bg-[rgb(var(--color-surface-muted))] text-[rgb(var(--color-text))]",
  pending_approval: "bg-[rgb(var(--color-warning))] text-[rgb(var(--color-text))]",
  approved:         "bg-[rgb(var(--color-success))] text-white",
  superseded:       "bg-[rgb(var(--color-info))] text-white",
  archived:         "bg-[rgb(var(--color-disabled))] text-[rgb(var(--color-text))]",
  released:         "bg-[rgb(var(--color-primary))] text-white",
  exported:         "bg-[rgb(var(--color-success))] text-white",
  certified:        "bg-[rgb(var(--color-success))] text-white",
};

export default function StatusPill({ status, ariaLabel }) {
  return (
    <span
      aria-label={ariaLabel || status}
      className={`inline-flex rounded-full px-2 py-1 text-tok-xs font-medium ${map[status] ?? "bg-[rgb(var(--color-surface-muted))] text-[rgb(var(--color-text))]"}`}
    >
      {status.replaceAll("_", " ")}
    </span>
  );
}
